// (c) chaehongee. Confidential and proprietary.

import { useEffect, useRef } from 'react'

interface UseSessionCleanupParams {
    sessionId: string | null
    onSessionChange: () => void
}

/**
 * Hook that detects session changes and triggers cleanup callbacks.
 * Used to reset canvas state (framing, history, etc.) when switching sessions.
 */
export function useSessionCleanup({ sessionId, onSessionChange }: UseSessionCleanupParams): void {
    const prevSessionIdRef = useRef<string | null>(null)

    useEffect(() => {
        const sid = sessionId ?? null
        if (prevSessionIdRef.current !== null && prevSessionIdRef.current !== sid) {
            onSessionChange()
        }
        prevSessionIdRef.current = sid
    }, [sessionId, onSessionChange])
}

